import { render, staticRenderFns } from "./FolderMoveModal.vue?vue&type=template&id=8cf8bb46"
import script from "./FolderMoveModal.ts?vue&type=script&lang=ts&external"
export * from "./FolderMoveModal.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports